import styled from 'styled-components'
import { space } from 'styled-system'
import { FlexDiv } from 'components/generic/HomePageComponents'

const GenericNavContainer = (props) => (
  <FlexDiv
    as='nav'
    display={['none', 'none', 'flex']}
    justifyContent='center'
    alignItems='center'
    position='fixed'
    top='0px'
    left='0px'
    padding='0 30px 0 0'
    height='90px'
    fontSize='15px'
    color='inverseColor'
    backgroundColor='#fff'
    width='100%'
    zIndex='1000'
    borderBottom='1px solid rgba(0,0,0,0.07)'
    boxShadow='0px 3px 8px -4px rgba(0,0,0,0.15)'
    {...props}
  />
)

export const LargeNavContainer = (props) => (
  <GenericNavContainer 
    display={['none', 'none', 'none', 'flex']}
    padding='0'
    margin='0 auto'
    boxShadow='none'
    width='100%'
    maxHeight='82px'
    top='0px'
    {...props} 
  />
)

export const LargeLogoContainer = styled.nav`
  height: 95%;
  margin: 0;
  padding: 0 20px;
`

export const NavigationItems = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: ${(props) => (props.isRight ? 'flex-end' : 'flex-start')};
  height: 100%;
`

export const NavigationItem = styled.div`
  height: 100%;
  padding: 0px 10px 0px 10px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0px 20px 10px;
  width: fit-content;
  margin-right:10px;
  margin-left: 10px;
`

const DropButton = styled.div`
  color: ${(props) => props.theme.colors.textColor};
  font-weight: normal;
  font-size: 15px;
  text-decoration: none;
  white-space: nowrap;
  .span:active {
    background-color: ${(props) => props.theme.colors.grey};
  }
`
const DropdownButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  :hover {
    ${DropButton} {
      color: ${(props) => props.theme.colors.inverseColor};
    }
  }
`
const DropdownContent = styled.div`
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 160px;
  width: fit-content;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  opacity: 0.9;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  ${space} 
`
const Dropdown = styled.div`
  height: 95%;
  position: relative;
  display: inline-block;
  white-space: nowrap;
  :hover {
    ${DropdownContent} {
      display: flex;
      flex-direction: row;
    }
    ${DropdownButtonContainer} {
      cursor: pointer;
      border-bottom: 3px solid;
      border-color: ${(props) => props.theme.colors.inverseColor};
    }
  }
  ${space}
`

export const CenteredContent = styled.div`
  white-space: nowrap;
`
// TODO: Should be a generic component
export const Anchor = styled.a`
  height: 100%;
  text-decoration: none;
  color: ${(props) => props.theme.colors.textColor};
  padding: 1px 0px;
  line-height: 21px;
  :hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.inverseColor};
  }
`
export const CenteringContainer = (props) => (
  <FlexDiv flexDirection='column' justifyContent='center' height='100%' boxSizing='border-box' {...props} />
)
export const DropdownAnchor = styled.a`
  height: 100%;
  text-decoration: none;
  color: ${(props) => props.theme.colors.textColor};
  padding: 12px 8px 12px 0px;
  line-height: 21px;
  :hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.inverseColor};
  }
`

// TODO: Should be a generic component
export const GenericDropdown = (props) => (
  <Dropdown minWidth='180px'>
    <DropdownButtonContainer>
      <DropButton>{props.title}</DropButton>
    </DropdownButtonContainer>
    <DropdownContent>{props.children}</DropdownContent>
  </Dropdown>
)

export const MyProfileAnchor = styled.a`
  height: 100%;
  text-decoration: none;
  color: ${(props) => props.theme.colors.textColor};
  padding: 12px 0px;
  min-width: 10px;

  :hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.inverseColor};
  }
`

export const MyProfileDropdown = (props) => (
  <Dropdown mr='10px' minWidth='80px'>
    <DropdownButtonContainer>
      <DropButton>{props.title}</DropButton>
    </DropdownButtonContainer>
    <DropdownContent>
      {props.children}
    </DropdownContent>
  </Dropdown>
)

export const MyProfileDropdownContainer = styled.div`
  display: flex;
  height: 95%;
  margin-right: 20px;
`
export const CountryH4 = styled.h4`
  font-weight: bold;
  white-space: no-wrap;
  margin-top: 10px;
  margin-bottom: 10px;
  color: ${(props) => props.theme.colors.textColor};
  font-size: 18px;
  line-height: 19px;
`

export const LogInDiv = styled.div`
color: ${(props) => props.theme.colors.textColor};
font-weight: normal;
font-size: 15px;
text-decoration: none;
.span:active {
  background-color: ${(props) => props.theme.colors.grey};
}
`

// Small header components
export const SmallNavContainer = (props) => (
  <GenericNavContainer
    display={['flex', 'flex', 'flex', 'none']}
    height='auto'
    {...props}
  />
)

export const SmallLogoContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 48px;
`

export const HamburgerMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const BaseHamburgerMenuBar = styled.div`
  background-color: #888;
  border-radius: 25px;
  height: 4px;
  margin-right: 10px;
  margin-left: auto;
  width: 30px;

  transition: all 0.3s ease-in-out;
`

export const HamburgerMenuTopBar = styled(BaseHamburgerMenuBar)`
  ${(props) => props.changed ? `transform: rotate(45deg) ; transform-origin: 6px 12px;` : ''}
`
/* Fade out the second bar */
export const HamburgerMenuMiddleBar = styled(BaseHamburgerMenuBar)`
  margin-top: 4px;
  ${(props) => (props.changed ? `opacity: 0;` : '')}
`

export const HamburgerMenuBottomBar = styled(BaseHamburgerMenuBar)`
  margin-top: 4px;
  ${(props) => props.changed ? `transform: rotate(-45deg); transform-origin: 10px -6px; ` : ''}
`

export const BaseHamburgerMenuItem = styled.a`
  text-align: center;
  margin: 8px 0;
  font-size: 16px;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
`

export const HamburgerMenuItem = styled(BaseHamburgerMenuItem)`
  background-color: #fff;
  width: 220px;
  font-weight: normal;
  border-radius: 5px;
  padding: 16px 16px 16px 16px;
  color: ${(props) => props.theme.colors.textColor};
  line-height: 22.85px;
  :hover {
    color: #ac8900;
    text-decoration: underline;
  }
`
export const SmallAnchor = styled.a`
  margin-left: 16px;
`

export const StyledNavPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: absolute;
  top: 48px;
  background-color: ${(props) => props.theme.colors.secondary};
  left: 0px;
  width: 100%;
  height: calc(100% - 48px);
  overflow-y: hidden;
  align-items: center;
  ${(props) => (props.show ? `display: flex;` : ` display: none;`)}
  @media (min-width: ${(props) => props.theme.breakpoints[2]}){
    display: none;
  }
`

export const SmallNavItemsTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
  padding-top: 60px;
`

export const LoggedInSmallNavItemsTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  padding-bottom: 80px;
`
export const SmallNavItemsBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
`